import { useRef, useState } from 'react'
import { AspectRatio } from '@mantine/core'
import { IconPlayerPlay } from '@tabler/icons-react'
import powerByDataplayr from '../../../assets/power-by-dataplayr.png'
import classes from './Video.module.css'

export default function Video({
  src,
  isMatch,
}: {
  src: string
  isMatch: boolean
}) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [hasBeenPlayed, setHasBeenPlayed] = useState(false)

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play()
      setHasBeenPlayed(true)
    }
  }

  return (
    <div className={classes.video_container}>
      <AspectRatio ratio={16 / 9}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <video
            ref={videoRef}
            controls={hasBeenPlayed}
            src={src}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
          {!hasBeenPlayed && (
            <div
              onClick={handlePlayClick}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                cursor: 'pointer',
                height: '98%',
              }}
            >
              <div
                style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'transform 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.1)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)'
                }}
              >
                <IconPlayerPlay size={40} color="white" fill="white" />
              </div>
            </div>
          )}
        </div>
      </AspectRatio>
      <div className={classes.video_desc} data-match={isMatch}>
        <a
          href="https://www.leaguestar.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt="Powered by Dataplayr"
            src={powerByDataplayr}
            height="25"
            width="84"
          />
        </a>
      </div>
    </div>
  )
}
